import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { constant } from '../../../app.constants';
import { T2CardComponent } from '../../../trip2-theme/components/t2-card/t2-card.component';
import { ReservationService } from '../reservations.service';
import { TripEditDriverVehicleComponent } from '../trip-edit-driver-vehicle/trip-edit-driver-vehicle.component';
import { TripModelR } from '../trip.model';
import { T2LoadingService } from '../../../trip2-theme/components/t2-loading/t2-loading.service';
import { assignNewObjet, validDateisBefore } from '../../A2-utils/export-functions/functions-services';
import { Subscription } from 'rxjs/Subscription';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ValidateTimesHelper, ValidateTimesHelperI } from 'app/core/helpers/validate-times-helper.service';

@Component({
  selector: 'app-change-status-to-complete',
  templateUrl: './change-status-to-complete.component.html',
  styleUrls: ['./change-status-to-complete.component.scss']
})

export class ChangeStatusToCompleteComponent implements OnInit, OnDestroy {
    @Input() companyId = 0;
    private trip = new TripModelR();
    @Input() tripid = 0;
    @Output() response = new EventEmitter<any>();
    @Input() signatureRequired: boolean;
    @Input() manifestRequired: boolean;
    @Input() requeridReason: boolean;
    @Input() isStandingOrder: boolean;
    protected timeMask = constant.MASK_TIME;
    protected signatures: any[];
    public viewCharged: boolean;
    public updatingData = false;
    public pickup: string;
    public viewReasonPU = false;
    public viewReasonDO = false;
    public validReasonDelay = true;
    public viewSave = false;
    private subscrip: Subscription[] = [];
    reservationLeg: string;
    errorMessage: String = 'Please enter a valid Pickup Time';
    private driverId: number;
    private vehicleId: number;

    @ViewChild('driverPopup') private driverpopover: TripEditDriverVehicleComponent;
    @ViewChild('driverManifest') private driverManifest: T2CardComponent;
    @ViewChild('modalCropper') private modalCropper: T2CardComponent;

  constructor(
    protected service: ReservationService,
    private _loading: T2LoadingService,
    private sweetAlertHelper: SweetAlertHelper,
  ) { }

  ngOnInit() {
      this.getTripData();
      this.getSignatures();
      this.subscribeToDriverAndVehicleId();
  }

  subscribeToDriverAndVehicleId(): void {
    this.subscrip.push(
      this.service
        .driverAndVehicleIdByEditDriverVehicleComponent$
        .subscribe({
          next: (value) => {
            if (!value) return;
            const { driverId, vehicleId } = value;
            this.driverId = driverId;
            this.vehicleId = vehicleId;
          }
        })
    );
  }

  getSignatures() {
    this.subscrip.push(
      this.service.getSignReason().subscribe((data) => {
        if (data) {
          this.signatures = data;
        }
      }, error => {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Error',
          text: error.mensage,
          type: 'error',
        });
      })
    );
  }

  initReasonForDelay(): void {
    if (this.trip.triplatereasonid && this.trip.triplatereasonid > 0) {
      const puValue = this.trip.pickupformatted;
      const addedOnValue = this.trip.addedon;
      const dosValue = this.trip.dateofserviceformatted;
      const appointmentValue = this.trip.appointment;
      const actualPU = this.trip.actualpickupformatted;
      const actualDO = this.trip.actualdropoffformatted;

      this.viewReasonPU = ValidateTimesHelper
      .validPickup({
        time: actualPU, pickup: puValue, addedon: addedOnValue,
        dateofservice: dosValue, currentLeg: this.reservationLeg
      });

      this.viewReasonDO = ValidateTimesHelper
      .validDropOff({
        time: actualDO, pickup: puValue, addedon: addedOnValue, dateofservice: dosValue,
        currentLeg: this.reservationLeg, appointmentCurrent: appointmentValue
      });
    }
  }

    /**
     * save the trip data
     */
    public completeTrip() {
        const date1 = new Date(this.addDateOfServiceTo(this.trip.actualpickupformatted));
        const date2 = new Date(this.addDateOfServiceTo(this.trip.actualdropoffformatted));
        this.updatingData = true;
        if (date1.getTime() >= date2.getTime()) {
            this.response.emit(
                    { success: false,
                            message: 'Actual PU time can not be greater to Actual DO Time'
                            }
                    );
            this.updatingData = false;
          return;
        }
        const driverAndVehicleData = this.driverpopover.getObjectData();

        if (driverAndVehicleData.vehicleid !== 0 &&
            driverAndVehicleData.vehicleid !== undefined &&
            driverAndVehicleData.driverid !== 0 &&
            driverAndVehicleData.driverid !== undefined &&
            this.reasonSignatureValid() &&
            this.trip.actualdropoffformatted !== '' &&
            this.trip.actualpickupformatted !== '') {
          this.trip.tripstatusid = 10;
          this.trip.driverid = driverAndVehicleData.driverid;
          this.trip.vehicleid = driverAndVehicleData.vehicleid;
          this.trip.actualpickup = this.addDateOfServiceTo(this.trip.actualpickupformatted);
          this.trip.actualdropoff = this.addDateOfServiceTo(this.trip.actualdropoffformatted);
          this.trip['passtocomplete'] = true;
          this.subscrip.push(this.service.putData(this.trip).subscribe(
            data => {
              this.response.emit(data);
              this.updatingData = false;
            }, error => {
              this.response.emit(error);
              this.sweetAlertHelper.captureExceptionList(error);
              this.updatingData = false;
            }
          ));
        }else {
          this.updatingData = false;
        }
    }

    /**
     * this add date to hour
     * @param string
     * @returns {string}
     */
    private addDateOfServiceTo(string) {
        return `${this.trip.dateofserviceformatted} ${string}`;
    }

    getTripData() {
        this.subscrip.push(
          this.service.getTripById(this.tripid).subscribe((data) => {
            this.trip = data;
            if (data && data.pickup) {
              this.pickup = data.pickup;
              this.reservationLeg = data.leg;
            } else {
              this.pickup = undefined;
              this.reservationLeg = data.leg;
            }
            this.initReasonForDelay();
          }, error => {
            this.sweetAlertHelper.createCustomAlert({
              title: 'Error',
              text: error.mensage,
              type: 'error',
            });
          })
        );
    }

    /**
     * validate if save button is enabled
     * @returns {boolean}
     */
    get disabledButton(): boolean {
      if (!this.vehicleId || !this.driverId) {
        return true;
      }

      if (!this.trip.actualdropoffformatted || !this.trip.actualpickupformatted) {
        return true;
      }

      if (!this.reasonSignatureValid()) {
        return true;
      }

      return !this.validReason();
    }

    /**@name reasonSignatureValid
     * @description valida si el signature es requerido y si esta completo
     * */
    reasonSignatureValid(): boolean {
      if (this.trip.tripreasonsignid !== 0 &&
        this.trip.tripreasonsignid !== undefined
        ) {
        return true;
      } else if (!this.signatureRequired) {
        return true;
      }else {
        return false;
      }
    }
  /**
   * @name openSignature
   * @description abre o cierra el modal - open or close the modal
   * @param close = datos success
   */
  openSignature(close?: any) {
    if (close && this.modalCropper.isOpen) {
     this.modifyData();
      this.modalCropper.close();
      this.sweetAlertHelper.createCustomAlert({
        title: 'Signature',
        text: close.message,
        type: 'success'
      });
    }else {
      this.modalCropper.open();
    }
  }

  /**
   * @name asignView
   * @description muestra boton para signature si tripreasonsignid = 5
   * @param event = tripreasonsignid
   */
  asignView(event) {
      if (!this.trip.signaturephoto) {
        event === 5 ? this.viewCharged = true : this.viewCharged = false;
      }else {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Signature',
          text: 'the signature is already loaded',
          type: 'info'
        });
      }
  }

  /**
   * @name modifyData
   * @description modifica la data del trip
   */
  modifyData() {
    this._loading.show();
    const data = assignNewObjet(this.trip);
    this.subscrip.push(this.service.getTripById(this.tripid).subscribe(
      success => {
        this.trip = success;
        this.trip.actualdropoffformatted = data.actualdropoffformatted;
        this.trip.actualpickupformatted = data.actualpickupformatted;
        if (this.trip['pickupformatted'] === '' ) { this.trip.pickup = data.pickup; }
        this._loading.hiden();
      }, () => {this._loading.hiden(); }
    ));
  }
  /**
   * @name validReason
   * @description valida accion y triplatereasonid segun los time
   */
  validReason(): boolean {
    let value = true;
    if (this.requeridReason && (this.viewReasonPU || this.viewReasonDO)) {
      value = !!this.trip.triplatereasonid;
    }
    return value;
  }
  generateValidDelay(date) {
    const pickupTime = this.pickup ? this.pickup : this.trip.pickup;
    this.validReasonDelay =  validDateisBefore(this.addDateOfServiceTo(date), this.addDateOfServiceTo(pickupTime));
  }


  validPickupImpl(time: string): void {
    const pickupTime = this.pickup ? this.pickup : this.trip.pickup;

    const objBody: ValidateTimesHelperI = {
      time: time,
      pickup: pickupTime,
      addedon: this.trip.addedon,
      dateofservice: this.trip.dateofserviceformatted,
      currentLeg: this.reservationLeg
    };

    if (this.requeridReason) {
      const isValid = ValidateTimesHelper.validPickup(objBody);
      let actualDropOff = this.trip.actualdropoffformatted;
      if (actualDropOff === null) { actualDropOff = ''; }

      if (isValid && this.trip.triplatereasonid && this.trip.triplatereasonid > 0) {
        this.trip.triplatereasonid = undefined;
      }

      this.viewReasonPU = isValid;
    }

    this.generateValidDelay(time);
  }

  validDropOffImpl(time: string): void {
    const pickupTime = this.pickup ? this.pickup : this.trip.pickup;

    const objBody: ValidateTimesHelperI = {
      time: time,
      pickup: pickupTime,
      addedon: this.trip.addedon,
      dateofservice: this.trip.dateofserviceformatted,
      currentLeg: this.reservationLeg,
      appointmentCurrent: this.trip.appointment
    };

    if (this.requeridReason) {
      const isValid = ValidateTimesHelper.validDropOff(objBody);
      let actualPickUp = this.trip.actualpickupformatted;
      if (actualPickUp === null) { actualPickUp = ''; }

      this.viewReasonDO = isValid;

      if (isValid && this.trip.triplatereasonid && this.trip.triplatereasonid > 0) {
        this.trip.triplatereasonid = undefined;
      }
    }
  }

  ngOnDestroy(): void {
    this.subscrip.forEach(sub => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/change-status-to-complete/change-status-to-complete.component.ts